import * as XLSX from 'xlsx';
var ExcelService = /** @class */ (function () {
    function ExcelService() {
    }
    ExcelService.prototype.exportAsExcelFile = function (json, excelFileName) {
        var worksheet = XLSX.utils.json_to_sheet(json);
        worksheet['A1'].s = {
            fill: { fgColor: { rgb: "D3D3D3" } },
            font: { name: 'Arial', sz: 10, bold: true },
            alignment: { wrapText: true, vertical: 'bottom', horizontal: 'center' }
        };
        var workbook = { Sheets: { 'report': worksheet }, SheetNames: ['report'] };
        XLSX.writeFile(workbook, excelFileName + '_export_' + new Date().getTime() + '.xlsx');
    };
    return ExcelService;
}());
export { ExcelService };



// WEBPACK FOOTER //
// ./src/app/excel.service.ts.pre-build-optimizer.js